"use client"
import React, {  useState } from 'react'
import {  useSelector } from 'react-redux'
import {  Title, } from '@/components'
import { TopProducts } from '@/components'

 const TesterCategory = () => {

    const [selectedCategory, setSelectedCategory] = useState("trials");
    const {allProducts,isLoader} = useSelector((state)=> state.allproducts)
    
 const filteredProducts = allProducts?.filter((item) =>
  selectedCategory === "trials"
    ? item.category === "trials"
    : selectedCategory === "women"
    ? item.category === "women"
    : item.category === "men"
);

   
  return (
    <>
    <Title title={`${selectedCategory} Category`} Subtitle={selectedCategory}/>
    <TopProducts filterData={filteredProducts}/>        
    </>
  )
}

export default TesterCategory